import {
  createCustomToggle,
  customSearchBar,
  cloneHeaderItems,
  updateContentMargin,
} from './helpers/helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  updateContentMargin();
  createCustomToggle();
  customSearchBar('Search on this website...');
  cloneHeaderItems();
});

// test comment
